<h3 class="end-title" i18n="Component 'end-chat', section title@@end_chat.title">Quelle suite te correspond le mieux ?</h3>

<div class="end-cards">

  <!-- Card 1 : Consultation par mail avec Isabella -->
  <a class="end-card mail" [href]="mailIsabellaUrl" target="_blank" rel="noopener" (click)="clickMail()">
    <div class="ec-head">
      <span class="ec-icon">
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="3" y="5" width="18" height="14" rx="2.5" stroke="currentColor" stroke-width="1.7"/>
          <path d="M4 7l8 6 8-6" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </span>
      <span class="ec-tag" i18n="Component 'end-chat', mail card tag@@end_chat.mail.tag">Avec Isabella</span>
    </div>
    <div class="ec-body">
      <img class="ec-avatar" src="assets/img/avatar.png" alt="Isabella">
      <p class="ec-title" i18n="Component 'end-chat', mail card title@@end_chat.mail.title">Consultation par Mail avec Isabella</p>
      <p class="ec-desc" i18n="Component 'end-chat', mail card description@@end_chat.mail.desc">Elle approfondit ton tirage et répond à tes questions en détail par écrit.</p>
    </div>
    <div class="ec-price"><span i18n="Component 'end-chat', mail card price@@end_chat.mail.price">5 €</span></div>
    <ul class="ec-checks">
      <li i18n="Component 'end-chat', mail card check 1@@end_chat.mail.check.0">Réponse sous 24h</li>
      <li i18n="Component 'end-chat', mail card check 2@@end_chat.mail.check.1">Échange privé et confidentiel</li>
      <li i18n="Component 'end-chat', mail card check 3@@end_chat.mail.check.2">Idéal pour prendre le temps de lire et relire ses réponses</li>
    </ul>
    <span class="ec-cta" i18n="Component 'end-chat', mail card CTA@@end_chat.mail.cta">Continuer par mail</span>
  </a>

  <!-- Card 2 : Experts Wengo -->
  <a class="end-card experts" [href]="expertsUrl" target="_blank" rel="noopener" (click)="clickExperts()">
    <div class="ec-head">
      <span class="ec-icon">
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8L12 3z" fill="currentColor"/>
        </svg>
      </span>
      <span class="ec-tag" i18n="Component 'end-chat', experts card tag@@end_chat.experts.tag">Experts Wengo</span>
    </div>
    <div class="ec-body">
      <p class="ec-title" i18n="Component 'end-chat', experts card title@@end_chat.experts.title">Consultation immédiate par téléphone, chat ou visio</p>
      <p class="ec-desc" i18n="Component 'end-chat', experts card description@@end_chat.experts.desc">Choisis un expert spécialisé en amour et relations pour obtenir des réponses tout de suite.</p>
    </div>
    <div class="ec-media">
      <span>
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6.5 4h3l1.5 4-2 1.5a11 11 0 0 0 5 5l1.5-2 4 1.5v3a2 2 0 0 1-2.2 2A16 16 0 0 1 4.5 6.2 2 2 0 0 1 6.5 4z" fill="currentColor"/>
        </svg>
      </span>
      <span>
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4 5h16a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H9l-4 3v-3H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1z" fill="currentColor"/>
        </svg>
      </span>
      <span>
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="3" y="6" width="13" height="12" rx="2" fill="currentColor"/>
          <path d="M16 10l5-3v10l-5-3v-4z" fill="currentColor"/>
        </svg>
      </span>
    </div>
    <ul class="ec-checks">
      <li i18n="Component 'end-chat', experts card check 1@@end_chat.experts.check.0">Disponible maintenant</li>
      <li i18n="Component 'end-chat', experts card check 2@@end_chat.experts.check.1">Échange en direct et personnalisé</li>
      <li i18n="Component 'end-chat', experts card check 3@@end_chat.experts.check.2">Nos meilleurs experts sélectionnés pour toi</li>
    </ul>
    <span class="ec-cta" i18n="Component 'end-chat', experts card CTA@@end_chat.experts.cta">Voir les experts disponibles</span>
  </a>

</div>

<h4 class="end-experts-title" i18n="Component 'end-chat', experts list title@@end_chat.experts_list.title">Nos experts recommandés pour toi</h4>

<swiper-container class="psychics" scrollbar="true" space-between="10" slides-per-view="auto">
  @for (psychic of experts; track psychic; let first = $first) {
    <swiper-slide>
      <a [href]="psychicUrl(psychic, $index)" class="psychic" [class.recommended]="first"
        target="_blank" (click)="clickPsychic(psychic)">
        @if (first) {
          <span class="badge"
          i18n="Expert card recommendation badge@@chat_component.expert.badge_recommended">Recommandée</span>
        }
        <img class="thumbnail" [src]="psychic.thumbnail" [alt]="psychic.title">
        <p class="title">{{psychic.title}}</p>
        @if (psychic.speciality) {
          <p class="speciality">{{psychic.speciality}}</p>
        }
        @if (psychic.stats_satisfaction) {
          <p class="stats">
            <span class="satisfaction">★ {{formatSatisfaction(psychic.stats_satisfaction)}} %</span>
            @if (psychic.stats_mkt_transaction) {
              <span class="volume"> · {{formatCount(psychic.stats_mkt_transaction)}}</span>
            }
          </p>
        }
        <span class="cta">
          @if (psychic.category === 'top') {
            <img class="cta-icon" src="assets/img/icon-phone.svg" alt="" width="12" height="12">
          }
          @if (psychic.category !== 'top') {
            <img class="cta-icon" src="assets/img/icon-envelope.svg" alt="" width="12" height="12">
          }
          <ng-container i18n="Expert card CTA@@chat_component.expert.cta_consult">Consulter</ng-container>
        </span>
      </a>
    </swiper-slide>
  }
</swiper-container>
